module.exports = __webpack_public_path__ + "static/media/uni-cc-05.bd07d940.png";